import { Box, CircularProgress } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { LoyaltyCurrencyIcon, useLoyaltyCurrencyFormat } from '@ocx/feat-loyalty-currency';
import { Paper, SizingMultiplier, Typography } from '@ocx/ui';

import { totalPointsEarnedMessages } from './total-points-earned.messages';

export type TotalPointsEarnedSectionProps = {
  pointsEarned: number;
  loading: boolean;
};

export const TotalPointsEarnedSection = ({ pointsEarned, loading }: TotalPointsEarnedSectionProps) => {
  const formatLoyaltyCurrency = useLoyaltyCurrencyFormat();

  const formattedValue = formatLoyaltyCurrency(pointsEarned);

  return (
    <Box px={SizingMultiplier.sm} pt={SizingMultiplier.sm}>
      <Paper p={0} sx={{ position: 'relative', overflow: 'hidden' }}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          py={SizingMultiplier.md}
          px={SizingMultiplier.md}
          sx={{ opacity: loading ? 0.1 : 1 }}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={SizingMultiplier.sm}>
            <LoyaltyCurrencyIcon variant="multiple" size="large" />
            <Typography component="p" variant="h2" sx={{ m: 0, textTransform: 'none' }}>
              {formattedValue}
            </Typography>
          </Box>
          <Typography component="p" variant="body2" align="center" sx={{ mt: SizingMultiplier.xs }}>
            <FormattedMessage {...totalPointsEarnedMessages['total-points-earned:subtitle']} />
          </Typography>
        </Box>
        {loading && (
          <Box position="absolute" display="flex" top={0} bottom={0} left={0} right={0}>
            <CircularProgress size={24} color="primary" sx={{ m: 'auto' }} />
          </Box>
        )}
      </Paper>
    </Box>
  );
};
